import React, { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Icon } from '../icon';
import Crown from '../svg/crown';

interface _ButtonActionsProps {
    $disabled?: boolean;
    $selected?: boolean;
}

const _ButtonActions = styled.div<_ButtonActionsProps>`
    width: 100%;
    display: block;
    padding: 6px 10px;
    border: none;
    border-radius: 6px;
    background: none;
    text-align: left;
    font-size: 13px;
    font-family: inherit;
    color: #263238;
    cursor: pointer;
    transition: all 0.12s ease;

    ${(props) =>
        props.$selected &&
        `
		color: #E8650A;
		background: #fff7ed;
	`}

    ${(props) => props.$disabled && `opacity: 0.5; pointer-events: none;`}

	&:hover {
        background: ${(props: _ButtonActionsProps) => (props.$selected ? '#ffedd5' : '#f3f4f6')};
    }
`;

interface ButtonActionsProps {
    disabled?: boolean;
    selected?: boolean;
    requireUpgrade?: boolean;
    onClick: () => void;
}

export const ButtonActions: FC<PropsWithChildren<ButtonActionsProps>> = ({ disabled, selected, requireUpgrade, onClick, children }) => {
    return (
        <_ButtonActions $selected={selected} $disabled={disabled} onClick={() => !disabled && onClick && onClick()}>
            {children}
            {requireUpgrade && (
                <Icon>
                    <Crown className='Upgrade'></Crown>
                </Icon>
            )}
        </_ButtonActions>
    );
};

export const ButtonActionsDelete = styled.div`
    width: 100%;
    display: block;
    padding: 8px 16px;
    border: none;
    background: none;
    text-align: left;
    font-size: 13px;
    font-family: inherit;
    color: #dc2626;
    cursor: pointer;
    transition: background 0.1s;

    &:hover {
        background: #fef2f2;
    }
`;
